// import-sort-ignore

export {
  default as entityPlugin,
  buildEntityActions,
  buildEntityApi,
  buildEntitySelectors,
  createEntitySelector,
  EntityActions,
  EntityActionTypes,
  entityStatuses,
  entityUtils,
  // Can be removed when these are moved into this package:
  // - `web/frontend/assets/app/entities/Auth`
  normalizePostError,
} from './entity';

export { createPrefixedActions, createReducer } from './redux-utils';

export {
  default as errorPlugin,
  ErrorSelectors,
  ErrorActionTypes,
  ErrorActions,
  resourceNames,
  commonErrors,
  hasErrorsOfType,
  // Can be removed when these are moved into this package:
  // - `web/frontend/assets/app/common/components/ErrorBar`
  isPermanentError,
  // Can be removed when these are moved into this package:
  // - `web/frontend/assets/app/common/components/ErrorModal`
  // - `web/frontend/assets/app/common/components/ErrorSummary`
  selectErrorMessages,
  // Can be removed when these are moved into this package:
  // - `web/frontend/assets/app/common/apollo/createNetworkInterface`
  createErrorType,
  // Can be removed when the logic in `web/frontend/assets/app.js` gets encapsulated in this package
  configureErrorTracking,
  trackException,
  // Can be removed when these are moved into this package:
  // - `web/frontend/assets/app/common/middlewares/sentryErrorsMiddleware`
  shouldIgnoreNetworkError,
  // Can be removed when these are moved into this package:
  // - `web/frontend/assets/app/common/apollo/createNetworkInterface`
  shouldTrackNetworkError,
} from './error';

//
// Utilities
//
import * as RouterSelectors from './utils/router-selectors';
export { RouterSelectors };

//
// Hooks
//
export { useRedux } from './hooks';

//
// Middleware
//
export {
  default as localStorageMiddleware,
  getLocalStorage,
  setLocalStorage,
} from './middleware/localStorageMiddleware';
